import { isEmpty } from 'lodash';
import { CSSProperties } from 'react';
import { Text, TextSize } from '@shared/components/Text';
import { View, ViewProps } from '@shared/components/View';

interface Props extends ViewProps {
  beginning: string;
  end?: string;
  textSize?: TextSize;
  style?: CSSProperties;
}

export function TruncateMiddle({ beginning, end = '', textSize, style, ...otherProps }: Props) {
  return (
    <View row {...otherProps}>
      <Text size={textSize} numberOfLines={1} style={{ ...truncationStyle, ...style }}>
        {beginning}
      </Text>
      {!isEmpty(end) && (
        <Text size={textSize} numberOfLines={1} style={style}>
          {end}
        </Text>
      )}
    </View>
  );
}

const truncationStyle: CSSProperties = {
  flexShrink: 1,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  display: 'inline-block',
};
